module.exports = "pegasus_template/assets/classic-facebook.png";